import { render, staticRenderFns } from "./GroundTruthAmount.vue?vue&type=template&id=08029214&scoped=true&"
import script from "./GroundTruthAmount.vue?vue&type=script&lang=js&"
export * from "./GroundTruthAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08029214",
  null
  
)

export default component.exports